<template>

  <canvas
    id="myCanvas" 
    class="canvas"
    :style="{backgroundImage:'url(' + bgColor + ')'}"
    @touchstart.prevent="start($event)"
    @touchmove.prevent="move($event)"
  >
  <!-- @touchend.prevent="end($event)" -->
  </canvas>

</template>

<script>
import CloseIcon from './image/close.png'
import ScaleIcon from './image/resize.png'
import GoUpIcon from './image/up.png'
var close = new Image();
var scale = new Image()
var goup = new Image()
close.src = CloseIcon
scale.src = ScaleIcon
goup.src  = GoUpIcon

class DragImg {
  constructor (img, canvas) {
    this.x = 75
    this.y = 80
    this.w = img.width
    this.h = img.height
    this.url = img.url
    this.flag = img.flag
    this.ctx = canvas
    this.rotate = 0
    this.selected = true
  }

  clear() {
    this.selected = false
  }

  paint () {
    this.ctx.save()
    this.centerX = this.x + this.w / 2
    this.centerY = this.y + this.h / 2
    // 旋转元素
    this.ctx.translate(this.centerX, this.centerY)
    this.ctx.rotate(this.rotate * Math.PI / 180)
    this.ctx.translate(-this.centerX, -this.centerY)
    // 渲染元素
    // console.log(this.url)
    this.ctx.drawImage(this.url, this.x, this.y, this.w, this.h)
    // 如果是选中状态，绘制选择虚线框，和缩放图标、删除图标
    if ( this.selected ) {
      this.ctx.setLineDash([5, 5])
      this.ctx.lineWidth = 2
      this.ctx.strokeStyle = 'white'
      this.ctx.lineDashOffset = 5
      this.ctx.strokeRect(this.x, this.y, this.w, this.h)
      if ( !this.flag ) {
        this.ctx.drawImage(close, this.x - 12, this.y - 12, 24, 24)
      }
      this.ctx.drawImage(scale, this.x + this.w - 12, this.y + this.h - 12, 24, 24)
      this.ctx.drawImage(goup, this.x + this.w - 12, this.y - 12, 24, 24)
    }
    this.ctx.restore()
  }

  isInWhere (x, y) {
    // 变换区域左上角的坐标和区域的高度宽度
    const transformW = 24
    const transformH = 24
    let transformX = this.x + this.w
    let transformY = this.y + this.h
    const transformAngle = Math.atan2(transformY - this.centerY, transformX - this.centerX) / Math.PI * 180 + this.rotate
    const transformXY = this.getTransform(transformX, transformY, transformAngle)
    transformX = transformXY.x; transformY = transformXY.y
    // 删除区域左上角的坐标和区域的高度宽度
    const delW = 24
    const delH = 24
    let delX = this.x
    let delY = this.y
    const delAngle = Math.atan2(delY - this.centerY, delX - this.centerX) / Math.PI * 180 + this.rotate
    const delXY = this.getTransform(delX, delY, delAngle)
    delX = delXY.x;
    delY = delXY.y
    // 右上角层级
    const upW = 24
    const upH = 24
    let upX = this.x + this.w
    let upY = this.y
    const upAngle = Math.atan2(upY - this.centerY, upX - this.centerX) / Math.PI * 180 + this.rotate
    const upXY = this.getTransform(upX, upY, upAngle)
    upX = upXY.x;
    upY = upXY.y
    // 移动区域的坐标
    const moveX = this.x
    const moveY = this.y
    if (x - transformX >= 0 && y - transformY >= 0 && transformX + transformW - x >= 0 && transformY + transformH - y >= 0) {
      // 缩放区域
      return 'transform'
    } else if (x - upX >= 0 && y - upY >= 0 && upX + upW - x >= 0 && upY + upH - y >= 0) {
      // 上移区域
      return 'up'
    } else if (x - delX >= 0 && y - delY >= 0 && delX + delW - x >= 0 && delY + delH - y >= 0) {
      // 删除区域
      return 'del'
    } else if (x - moveX >= 0 && y - moveY >= 0 && moveX + this.w - x >= 0 && moveY + this.h - y >= 0) {
      // 移动区域
      return 'move'
    }
    // 不在选择区域里面
    return false
  }

  getTransform (x, y, rotate) {
    // 将角度化为弧度
    var angle = Math.PI / 180 * rotate
    // 初始坐标与中点形成的直线长度不管怎么旋转都是不会变的，用勾股定理求出然后将其作为斜边
    var r = Math.sqrt(Math.pow(x - this.centerX, 2) + Math.pow(y - this.centerY, 2))
    // 斜边乘sin值等于即可求出y坐标
    var a = Math.sin(angle) * r
    // 斜边乘cos值等于即可求出x坐标
    var b = Math.cos(angle) * r
    // 目前的xy坐标是相对于图片中点为原点的坐标轴，而我们的主坐标轴是canvas的坐标轴，所以要加上中点的坐标值才是标准的canvas坐标
    return {
      x: this.centerX + b - 12,
      y: this.centerY + a - 12
    }
  }
}

export default {
  name: 'canvas-drag',
  props: {
    imgArr: {
      type: Array,
      default () {
        return []
      }
    },
    bgColor: {
      type: String
    }
  },
  data () {
    return {
      ctx: null,
      dragArr: [],
      clickedkArr: [],
      c: null,
      lastImg: null,
      initial: null,
      startTouch: null,

      extraImgList: [
          {url:require("@/images/create/bg/1.png"), x: 0, y: 0, width: 535, height: 536}
      ],
    }
  },
  mounted () {
    const c = document.getElementById('myCanvas')
    this.c = c
    // 初始
    // const { width, height } = window.screen
    // c.width = width - 2
    // c.height = height * 0.75
    // 修改
    // const { clientWidth, clientHeight } = document.documentElement
    const { clientWidth, clientHeight } = c
    c.width = clientWidth
    c.height = clientHeight
    // c.width = 534
    // c.height = 534
    // console.log(c)
    this.ctx = c.getContext('2d')
    // this.loadImg();
    console.log('mounted')
  },
  methods: {
    loadImg() {
      var img = new Image();
      img.src = require("@/images/create/bg/1.png");
      // img.onload = imgfn;//图片加载完在执行
      img.onload = () => {
        // console.log(444)
        // this.ctx.save();
        // this.ctx.translate(0, -1000);
        var bg = this.ctx.createPattern(img, "no-repeat");//createPattern() 方法在指定的方向内重复指定的元素。
        this.ctx.fillStyle = bg;//fillStyle 属性设置或返回用于填充绘画的颜色、渐变或模式。
        this.ctx.fillRect(0, 0, this.c.width, this.c.height);//绘制已填充矩形fillRect(左上角x坐标, 左上角y坐标, 宽, 高)
        // this.ctx.restore();
        // this.ctx.save();
        // this.ctx.restore();
        // this.ctx.drawImage(img, 0, 0);
      }
      // var _this = this;
      // let extraImgList = _this.extraImgList;
      // let length = extraImgList.length;
      // var imageList = [];
      // let count = 0;
      // //加载背景图片
      // // var isBgLoaded = false;
      // var img = new Image();
      // var bgImg = extraImgList[0];
      // console.log(bgImg)
      // console.log(11)
      // img.src = bgImg.url;
      // img.onload = () => {
      //   imageList.push({img: img, x: bgImg.x, y: bgImg.y, width: bgImg.width, height: bgImg.height});
      //   ++count;
      //   if (length > 1) {
      //     //加载剩余图片
      //     for(let key = 0; key < length; key++) {
      //       let item = extraImgList[key];
      //       let extarImg = new Image();
      //       extarImg.src = item.url;
      //       extarImg.onload = () => {
      //         imageList.push({img: extarImg, x: item.x, y: item.y, width: item.width, height: item.height})
      //         if(++count >= length) {
      //           console.log(22)
      //           _this.imgObject = imageList;
      //           _this.drawImage(imageList);
      //         }
      //       }
      //     }
      //   } else {
      //     console.log(123)
      //     _this.imgObject = imageList;
      //     _this.drawImage(imageList);
      //   } 
      // }
    },
    // drawImage(imgList) {
    //   console.log(imgList)
    //   console.log(33)
    //   var _this = this;
    //   console.log(this.c);
    //   // _this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    //   this.ctx.clearRect(0, 0, this.c.width, this.c.height)
    //   for(let i = 0; i < imgList.length; i++) {
    //     console.log(imgList[i])
    //     // _this.ctx.drawImage(
    //     //   imgList[i].img,
    //     //   _this.imgX + imgList[i].x * _this.imgScale, _this.imgY+ imgList[i].y * _this.imgScale,
    //     //   imgList[i].width*_this.imgScale, imgList[i].height*_this.imgScale
    //     // );
    //     _this.ctx.drawImage(
    //       imgList[i].img,
    //       imgList[i].x, imgList[i].y,
    //       imgList[i].width, imgList[i].height
    //     );
    //   }
    // },
    moveArray(arr, sourceIndex, targetIndex) {
      arr[sourceIndex] = arr.splice(targetIndex, 1, arr[sourceIndex])[0];
    },
    draw(type=1) {
      this.ctx.clearRect(0, 0, this.c.width, this.c.height)

      // 选中开始
      if (type==2) {
        console.log(type);
        let dragArr = this.dragArr;
        var sourceIndexes = [];
        dragArr.forEach((item, index) => {
          if (item.selected) {
            sourceIndexes.push(index);
          }
        });
        sourceIndexes.forEach((sourceIndex) => {
          this.moveArray(dragArr, sourceIndex, dragArr.length);
        });
        var result = dragArr.filter((item) => {
          return item !== undefined || !!item;
        });
        this.dragArr = result;
      }
      // 选中结束

      // result.forEach((item) => {
      this.dragArr.forEach((item) => {
        item.paint()
      })
    },
    // end (e) {
    //   console.log(e)
    //   this.draw();
    // },
    start (e) {
      console.log(this.ctx);
      console.log(e);
      // 初始化一个数组用于存放所有被点击到的图片对象
      this.clickedkArr = []
      // 初始
      const x = e.touches[0].clientX - this.$parent.$refs.create.offsetLeft
      const y = e.touches[0].clientY- this.$parent.$refs.main.offsetTop-this.$parent.$refs.create.offsetTop
      // 修改
      // const x = e.changedTouches[0].clientX 
      // const y = e.changedTouches[0].clientY
      // const x = e.targetTouches[0].clientX - this.ctx.offsetLeft;
      // const y = e.targetTouches[0].clientY - this.ctx.offsetTop;
      this.dragArr.forEach((item, index) => {
        const place = item.isInWhere(x, y)
        item.place = place
        item.index = index
        // 先将所有的item的selected变为flase
        item.selected = false
        if (place) {
          this.clickedkArr.push(item)
        }
      })
      const length = this.clickedkArr.length
      var type=1
      if (length) {
        // 我们知道cavans绘制的图片的层级是越来越高的，因此我们取这个数组的最后一项，保证取到的图片实例是层级最高的
        const lastImg = this.clickedkArr[length - 1]
        // 如果是删除的话就移除
        if ( lastImg.place === 'del' && lastImg.flag==0 ) {
          console.log('del')
          this.dragArr.splice(lastImg.index, 1)
          // 重新绘制
          this.draw()
          return
        }
        // 将该实例的被选值设为true，下次重新绘制将绘制边框
        lastImg.selected = true
        // console.log(lastImg)
        // 保存这个选中的实例
        this.lastImg = lastImg
        // 保存这个实例的初始值，以后会用上
        this.initial = {
          initialX: lastImg.x,
          initialY: lastImg.y,
          initialH: lastImg.h,
          initialW: lastImg.w,
          initialRotate: lastImg.rotate
        }
        if (lastImg.place === 'up') {
          console.log('up')
          // 重新绘制
          // this.draw(2)
          // return
          type = 2
        }
      }
      // 重新绘制
      this.draw(type)
      
      // 保存点击的坐标，move时要用
      this.startTouch = { startX: x, startY: y }
    },
    move (e) {
      // console.log(this.initial)
      // 初始
      const x = e.touches[0].clientX - this.$parent.$refs.create.offsetLeft
      const y = e.touches[0].clientY - this.$parent.$refs.main.offsetTop- this.$parent.$refs.create.offsetTop

      // 修改
      // const x = e.changedTouches[0].clientX 
      // const y = e.changedTouches[0].clientY
      // const x = e.targetTouches[0].clientX - this.ctx.offsetLeft;
      // const y = e.targetTouches[0].clientY - this.ctx.offsetTop;
      
      if (this.clickedkArr.length) {
        const { initialX, initialY } = this.initial
        const { startX, startY } = this.startTouch
        const lastImg = this.lastImg

        if (this.lastImg.place === 'move') {
          // 算出移动后的xy坐标与点击时xy坐标的差（即平移量）与图片对象的初始坐标相加即可
          lastImg.x = initialX + (x - startX)
          lastImg.y = initialY + (y - startY)
        }

        if (this.lastImg.place === 'transform') {
          const { centerX, centerY } = lastImg
          // 旋转部分
          const { initialRotate } = this.initial
          const angleBefore = Math.atan2(startY - centerY, startX - centerX) / Math.PI * 180
          const angleAfter = Math.atan2(y - centerY, x - centerX) / Math.PI * 180
          // 旋转的角度
          lastImg.rotate = initialRotate + angleAfter - angleBefore
          // 缩放部分
          const { initialH, initialW } = this.initial
          // 用勾股定理算出距离
          const lineA = Math.sqrt(Math.pow(centerX - startX, 2) + Math.pow(centerY - startY, 2))
          const lineB = Math.sqrt(Math.pow(centerX - x, 2) + Math.pow(centerY - y, 2))
          const w = initialW + (lineB - lineA)
          // 由于是等比缩放，所以乘一个宽高比例。
          const h = initialH + (lineB - lineA) * (initialH / initialW)
          // 定义最小宽高
          lastImg.w = w <= 5 ? 5 : w
          lastImg.h = h <= 5 ? 5 : h
          if (w > 5 && h > 5) {
            // 放大 或 缩小
            lastImg.x = initialX - (lineB - lineA) / 2
            lastImg.y = initialY - (lineB - lineA) / 2
          }
        }
        this.draw()
      }
    },
    reset() {
      this.dragArr.splice(0, this.dragArr.length)
      this.ctx.clearRect(0, 0, this.c.width, this.c.height)
    },
    clear() {
      this.dragArr.forEach(item => {
        item.clear();
      })
      this.draw()
    }
  },
  watch: {
    imgArr (arr) {
      if (arr.length) {
        const newImg = arr.slice(-1)[0]
        // console.log(newImg)
        const item = new DragImg(newImg, this.ctx)
        this.dragArr.push(item)
        // console.log(this.dragArr)
        this.draw()
      }
    }
  }
}
</script>

<style scoped lang="less">
.canvas {
  background-color: transparent;
  // border: 1px solid red;
  // width: 100%;
  // height: 100%;
  border-radius: 20px;
  width: 535px;
  height: 536px;
  // background: url(var(bgColor)) no-repeat;
  background-size: 100%;
  // position: absolute;
  // z-index: 3;
  // top: 22px;
  // left: 0;
  // right: 0;
}
</style>